import { RefObject, useLayoutEffect, useState } from 'react';

import useWindowDimensions from 'lib/hooks/useWindowDimensions';

/**
 * @name `useIsOverflow`
 *
 * A hook that returns whether the referenced div has overflown.
 *
 */
export const useIsOverflow = (ref: RefObject<HTMLDivElement>) => {
  const [isOverflow, setIsOverflow] = useState(undefined);
  const windowDimensions = useWindowDimensions();

  useLayoutEffect(() => {
    const { current } = ref;

    const trigger = () => {
      const hasOverflow =
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        current.scrollHeight > current.clientHeight || current.scrollWidth > current.clientWidth;

      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      setIsOverflow(hasOverflow);
    };

    if (current) {
      trigger();
    }
  }, [ref, windowDimensions]);

  return isOverflow;
};
